import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background":"#ECECEC"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailReport = _resolveComponent("EmailReport")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_SMSReport = _resolveComponent("SMSReport")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { title: "Transaction Logs" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            (_ctx.actionChecker('transaction_logs', 'view_email'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "1",
                  tab: "Email Report"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EmailReport)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.actionChecker('transaction_logs', 'view_sms'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "2",
                  tab: "SMS Report"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SMSReport)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    })
  ]))
}